// userSelectors.js

export const selectLoading = (state) => state.ondemand.loading;
export const selectSuccessData = (state) => state.ondemand.successData;
export const selectOndemandHealthRecordList = (state) => state.ondemand.healthRecordList;
export const selectUploadSuccessData = (state) => state.ondemand.uploadSuccess;
